import { render, staticRenderFns } from "./SkillsSheet.vue?vue&type=template&id=31bf06f4"
import script from "./SkillsSheet.vue?vue&type=script&lang=js"
export * from "./SkillsSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports